import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/subscriptions/price/{stripePriceId}/proration-data';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getProrationData = async ({ stripePriceId }: Input ): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { stripePriceId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getProrationData;